import type { StripeElementStyle, StripeElementStyleVariant } from '@stripe/stripe-js'
import { default as coreTokens } from 'design-tokens/core.json'
import { default as semanticTokens } from 'design-tokens/semantic.json'
import type { IbanElementStripeProps } from './StripeSEPADebitFields/types'
import type { CardElementStripeProps } from './StripeCCFields/types'

const fgContentPrimaryColor = semanticTokens['betterplace-color-fg-content-primary']
const fgMuteColor = semanticTokens['betterplace-color-fg-mute']
const fgDangerColor = semanticTokens['betterplace-color-fg-danger']
const fontWeight = coreTokens['betterplace-font-weights-regular']

/**
 * Using rem for lineHeight and fontSize produces unexpected results:
 * - not right font size
 * - or if both of them are set the input height grows to 3x bigger
 */

export const invalidStyle = {
  color: fgDangerColor,
  iconColor: fgDangerColor,
}

// Stripe merges style updates, so this must explicitly overwrite every key of invalidStyle
export const validStyle = {
  color: fgContentPrimaryColor,
  iconColor: fgContentPrimaryColor,
}

const baseStyle = {
  'color': fgContentPrimaryColor,
  'lineHeight': '24px',
  'fontFamily': '"Fira Sans", Helvetica, sans-serif', // Fira Sans will only work once we enable it the element options
  'fontSmoothing': 'antialiased',
  'fontSize': '16px',
  'fontWeight': fontWeight,
  '::placeholder': {
    color: fgMuteColor,
  },
}

function getBaseStyleWithOverrides(overrides: StripeElementStyleVariant | undefined) {
  return { ...baseStyle, ...overrides }
}

export function getIbanElementProps({ base, ...rest }: StripeElementStyle = {}): IbanElementStripeProps {
  return {
    options: {
      supportedCountries: ['SEPA'],
      placeholderCountry: 'DE',
      style: { base: getBaseStyleWithOverrides(base), invalid: invalidStyle, ...rest },
    },
  }
}

export function getCcElementProps(style?: StripeElementStyle): CardElementStripeProps {
  return {
    options: {
      hidePostalCode: true,
      style: { base: baseStyle, invalid: invalidStyle, ...style },
    },
  }
}
